import NextLink from "next/link";

export enum DreamIDType {
  AuditEvent = "ae",
  Customer = "cu",
  Enrollment = "en",
  Program = "pg",
  Provider = "tp",
  PaymentOption = "po",
  User = "us",
}

interface RenderCuidLinkProps {
  code: string | null | undefined;
  type: DreamIDType;
  link: string;
}

export const RenderCuidLink = ({ code, type, link }: RenderCuidLinkProps) => {
  if (!code || !link) {
    return null;
  }

  return (
    <NextLink href={link} legacyBehavior>
      <a>
        <code>
          {type}/&hellip;{code.slice(code.length - 6)}
        </code>
      </a>
    </NextLink>
  );
};
